export default __webpack_public_path__ + "static/media/icon-wallet.da5daae0.svg";